
import { useState } from "react";
import Config from "../../Config";
import List from "./List";
import Kid from "./Kid";

 

  


function RaportView(props)
{
 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
    }

    if(props.mainView.viewSelected == 'kid' || props.mainView.viewSelected == undefined )
        {

            document.title ="Lista raportów / Dziecko"; 

          

            return (
                <div className="econtent ">                                                                      
                      <Kid  userData={props.userData}  mainView={props.mainView}  />    
                 </div>
            )
        }


    if(props.mainView.viewSelected == 'list'   )
        {

            document.title ="Lista raportów / Raporty"; 

          

            return (
                <div className="econtent ">                                                                      
                      <List  userData={props.userData}  mainView={props.mainView}  />    
                 </div>
            )
        }
    


    return (
        <div className="econtent ">
             { "View, op: " +  props.mainView.viewSelected}
        </div>
    );
 
}


export default RaportView;